var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-dropdown',_vm._b({attrs:{"value":_vm.displayLanguage,"label":_vm.$t('authenticationLanguageLabel'),"options":_vm.options},on:{"input":_vm.input,"change":_vm.change}},'input-dropdown',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }